import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
function Breadcrumb() {
  return (
    <div className="breadcrumbStyle">
      <Link to="/">Trang chủ</Link>
      <span className="breadcrumbSeparator">
        <FontAwesomeIcon icon="angle-right" />
      </span>
      <span className="active">
        <Link to="/hotel">Khách sạn</Link>
      </span>
    </div>
  );
}
export default Breadcrumb;
